<template>
    <div class="learn" :class="{mb: mobile}" v-if="loading">
        <!-- Left -->
        <div class="_left" :class="{mb: mobile}" v-show="(!type && !mobile) || (showMenu && mobile)">
            <leftLearn :course="course"></leftLearn>
            <div v-if="disableMenu" class="disable__menu"></div>
        </div>

        <!-- Kc -->
        <div class="_kc" v-show="!type && !mobile"></div>

        <!-- Content -->
        <div class="_content" :class="{full_contain_pc: (type && !mobile) || mobile}" v-if="loadingContent">
            <contentLearn @loadLesson="loadingLesson" v-if="!mobile" :course="course"></contentLearn>
            <contentLearnMobile v-if="mobile" :course="course"></contentLearnMobile>
            <div class="fullScreen" @click="type = !type" v-if="!mobile">
                <img v-if="!type" src="/static/images/dbleft.png"/>
                <img v-else src="/static/images/dbright.png"/>
            </div>
        </div>
    </div>
</template>

<script>
    import leftLearn from "@/components/learn/left.vue"
    import contentLearn from "@/components/learn/content.vue"
    import contentLearnMobile from "@/components/learn/contentLearnMobile.vue"
    import { mapState, mapMutations } from "vuex"

    export default {
        name: "learn",
        data() {
            return {
                course: {},
                loadingContent: true,
                loading: false,
                type: false,
                disableMenu: false,
            };
        },
        created() {
            this.$autoLogin().then(
                () => {
                    this.init();
                },
                () => {
                    this.$router.push({
                        path: "/home",
                    });
                }
            );
        },
        computed: {
            ...mapState({
                activeID : (state) => state.learn.activeID,
                menuList : (state) => state.learn.menuList,
                mobile   : (state) => state.header.mobile,
                showMenu : (state) => state.learn.showMenu,
                resize   : (state) => state.learn.resize
            }),
        },
        components: { leftLearn, contentLearn, contentLearnMobile },
        watch: {
            activeID (newValue) {

                this.course.activeID = newValue;
                this.loadingContent  = false;
                this.disableContent  = true;

                this.$nextTick(() => {
                    this.loadingContent = true;
                });
            },

            type (value) {
                this.setResize(value);
            },

            $route(to, form) {
                let outlineInfo = eval("(" + to.query.outlineInfo + ")");
                let info = JSON.parse(JSON.stringify(outlineInfo));

                this.course.id = info.courseId;
                this.course.name = info.courseName;
                this.course.activeID = info.activeID;
                this.course.redirectType = info.redirectType;
                
                this.loading = false;
                this.$nextTick(() => {
                    this.loading = true;
                });
            }
        },
        methods: {
            init: function () {
                this.userId = this.$attrs.userId || window.sessionStorage.getItem("id");
                let outlineInfo = eval("(" + this.$route.query.outlineInfo + ")");
                let info = JSON.parse(JSON.stringify(outlineInfo));

                this.course.id = info.courseId;
                this.course.name = info.courseName;
                this.course.activeID = info.activeID;
                this.course.redirectType = info.redirectType;

                this.loading = true;
            },

            loadingLesson (val) {
                this.disableMenu = val;
            },

            ...mapMutations("learn", ["setResize"]),
        }
    };
</script>

<style scoped>
    .disable__menu {
        position: absolute;
        height: 100%;
        width: 100%;
        background: transparent;
        z-index: 100;
        top: 0;
        left: 0;
    }
    .full_contain_pc {
        width: 100% !important;
    }
    .learn.mb {
        position: absolute;
        top: 0;
        left: 0;
    }
    .learn {
        width: 100%;
        max-width: 1200px;
        height: 100%;
        display: flex;
        position: relative;
    }
    ._left {
        width: 28%;
    }
    ._left.mb {
        position: fixed;
        z-index: 11;
        background: #fff;
        height: 100%;
        width: 100%;
        transition: ease 0.5s;
    }
    ._kc {
        width: 2%;
    }
    ._content {
        width: 70%;
        position: relative;
    }
    .fullScreen {
        position: absolute;
        left: 0;
        top: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 1;
        background: #75686824;
    }
    .fullScreen img {
        width: 46px;
        margin: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/curriculum/learn.vue